import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '../../theming/ThemeProvider'
import { Checkbox } from 'react-native-paper'

export default function CheckBox ({ checked, size, color, ...props }) {
  const { theme } = useTheme()
  return (
    <Checkbox
      color={theme[color || 'BUNKER']}
      status={checked ? 'checked' : 'unchecked'}
      {...props}
    />
  )
}

CheckBox.propTypes = {
  checked: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.number,
  onPress: PropTypes.func,
  testID: PropTypes.string
}

CheckBox.defaultProps = {
  checked: false,
  color: '',
  size: 10,
  onPress: () => {},
  testID: null
}
